import SocketStore from '../../stores/SocketStore';
import { getShapeIcon, SHAPES, ToolWidth } from '../../helpers/statics';
import { observer } from 'mobx-react';
import './index.css';
import { DomPurifyHtml } from '../DomPurifyHtml';

const ShapesContainer = () => {


  return (
    <div className="customer-call-container-shapes"
    >
      {SocketStore.shapes.map((_shape, index) => {
        return (
          <div key={index} className="customer-call-container-shape" style={{
            left: _shape.x - ToolWidth / 2,
            top: _shape.y - ToolWidth / 2
          }}>
            <DomPurifyHtml
              className="customer-call-container-shape-icon"
              html={getShapeIcon(_shape)}
              style={{
                width: ToolWidth,
                height: ToolWidth,
              }}
            />
          </div>
        )
      })}

      {SocketStore.freeHandShapeLocation && SocketStore.freeHandShapeLocation.x !== -1 && SocketStore.freeHandShapeLocation.y !== -1 && (
        <div className="customer-call-container-shape" style={{
          left: SocketStore.freeHandShapeLocation.x - ToolWidth / 2,
          top: SocketStore.freeHandShapeLocation.y - ToolWidth / 2,
        }}>
          <DomPurifyHtml
            className="customer-call-container-shape-icon"
            html={getShapeIcon({ shape: 'free-hand', color: SocketStore.freeHandShapeLocation.color || SocketStore.selectedShapeColor })}
            style={{
              width: ToolWidth,
              height: ToolWidth,
            }}
          />
        </div>
      )}
    </div>
  )
}

export default observer(ShapesContainer);